import { useIsNumeric } from "../../hooks/useIsNumeric";

import "./style.css"

function InputText({ label, placeholder, value, setValue, field }) {
    const isNumeric = useIsNumeric();

    const inputNumber_list = ['phone'];

    const updtValue = (e) => {
        let newValue = e.target.value.replace(/[<>{}]/g, '');
        
        if (!inputNumber_list.includes(field) || newValue === '') {
            setValue(prev => ({ ...prev, [field]: newValue }));
            return
        }

        if (field === 'phone') {
            newValue = newValue.replace(/\s+/g, '');
            
            if (!isNumeric(newValue)) return

            let formattedString = '';

            for (let i = 0; i < newValue.length; i++) {
                formattedString += newValue[i];
                
                if ((i + 1) % 2 === 0 && i < newValue.length - 1) {
                    formattedString += ' ';
                }
            }

            newValue = formattedString;

            setValue(prev => ({ ...prev, [field]: newValue }));
        }
    }

    return (
        <div className="input_text">
            <label>{label}</label>

            <input
                type="text"
                placeholder={placeholder}

                value={value}
                onChange={e => updtValue(e)}
            />
        </div>
    )
}

export default InputText;